// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"1564702d","198":"bea567d5","404":"2d791a60","498":"55195f35","787":"accd547f"}[chunkId] + ".chunk.js";
};